import 'twin.macro';

import React from 'react';
import tw from 'twin.macro';

import AppStoreIcon from '@/assets/images/icons/AppStoreIcon';
import GooglePlayIcon from '@/assets/images/icons/GooglePlayIcon';
import PhoneAppImage from '@/assets/images/PhoneAppImage.png';
import { BigTitle, SubTitle } from '@/components';
function LandingInfoBanner() {
  return (
    <div tw='bg-[#444444] rounded-[20px] pt-5 px-5 flex sm:flex-row flex-col-reverse gap-20'>
      <img src={PhoneAppImage} alt='' />
      <div tw='flex flex-col gap-5'>
        <BigTitle
          text={'Управляйте счетами и картой из приложения'}
          twStyle={tw`sm:text-[24px] md:text-[24px] xl:text-[30px] text-[#70FF6E] `}
        />
        <SubTitle
          text={'Переводы на карты, SWIFT-переводы, конвертации, оплата услуг, реквизиты счетов и многое другое.'}
        />

        <div tw='flex gap-2 w-full'>
          <AppButton href='https://api.bankffin.kz/app/to' target='_blank'>
            <GooglePlayIcon />
          </AppButton>
          <AppButton href='https://api.bankffin.kz/app/to' target='_blank'>
            <AppStoreIcon />
          </AppButton>
        </div>
      </div>
    </div>
  );
}

const AppButton = ({ children, ...props }) => {
  return (
    <a tw='h-[48px] rounded-[8px] bg-black flex items-center justify-center px-10' {...props}>
      {children}
    </a>
  );
};

export default LandingInfoBanner;
